/** "Name (ASxxxx)"; the bare AS number without a name; null without an AS number. */
export function formatAsn(asn: string | null | undefined, name: string | null | undefined): string | null {
  if (!asn) return null;
  const trimmed = name?.trim();
  return trimmed ? `${trimmed} (${asn})` : asn;
}
